
import {ComponentType, ReactElement} from 'react'
import {flowRight as compose} from 'lodash'
import {Link} from 'react-router-dom'
import {I18nContextValues, Trans, withNamespaces} from 'react-i18next'
import withStyles, {StyledComponentProps} from '@material-ui/core/styles/withStyles'
import InfoIcon from '@material-ui/icons/InfoOutlined'
import {Grid, Typography} from '@material-ui/core'
import messages from '../../../../../../../assets/messages'
import {Account} from '../../../../types'
import {styles} from './styles'

type OpenPositionsNotificationPropsBase = {
  account: Account
}

type OpenPositionsNotificationProps = OpenPositionsNotificationPropsBase & StyledComponentProps & I18nContextValues

const Component = (props: OpenPositionsNotificationProps): ReactElement => {
  const {classes = {}, account} = props

  return (
    <Grid item xs={12} className={classes.container}>
      <Grid container>
        <Grid item xs={12}>
          <InfoIcon className={classes.infoIcon}/>
          <Typography variant="subtitle1" className={classes.subtitle}>
            <Trans {...messages.copyingOpenPositions} />
          </Typography>
        </Grid>
        <Grid item xs={12} className={classes.text}>
          <Typography variant="body1">
            <Trans {...messages.strategyOpenPositions} />
          </Typography>
        </Grid>
        <Grid item xs={12} className={classes.controls}>
          <Link to={`/accounts/${account.id}`} className={classes.link}>
            <Trans {...messages.managePositions} />
          </Link>
          <Link to={'/accounts'} className={classes.link}>
            <Trans {...messages.changeAccount} />
          </Link>
        </Grid>
      </Grid>
    </Grid>
  )
}

export const OpenPositionsNotification: ComponentType<OpenPositionsNotificationPropsBase> = compose(
  withStyles(styles),
  withNamespaces(),
)(Component)
